/* eslint-disable @typescript-eslint/typedef */
import { createAction } from '@reduxjs/toolkit';
import { Optional } from '../../../Utils/Types/Optional';

const fetchDailyGame = createAction<Optional<string>>('dailyGame/fetchDailyGame');

export default {
  fetchDailyGame
};
